var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container my-2" }, [
    _c("h1", { staticClass: "mb-3" }, [
      _vm._v(
        "\n        Zahlungsaufforderungen an " +
          _vm._s(_vm.recipientLabel) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-4" }, [
      _c("div", { staticClass: "card-body" }, [
        _vm.paymentRequestData.recipientName
          ? _c("p", { staticClass: "mb-1" }, [
              _c("strong", [_vm._v("Name:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.paymentRequestData.recipientName) +
                  "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.paymentRequestData.recipientMail
          ? _c("p", { staticClass: "mb-1" }, [
              _c("strong", [_vm._v("E-Mail:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.paymentRequestData.recipientMail) +
                  "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.paymentRequestData.iban
          ? _c("p", { staticClass: "mb-1" }, [
              _c("strong", [_vm._v("IBAN:")]),
              _vm._v(
                " " + _vm._s(_vm.paymentRequestData.iban) + "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.paymentRequestData.paymentName
          ? _c("p", { staticClass: "mb-0" }, [
              _c("strong", [_vm._v("Zahlungsempfänger:")]),
              _vm._v(
                " " +
                  _vm._s(_vm.paymentRequestData.paymentName) +
                  "\n            "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.isLoading
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [_c("csp-loading-indicator")],
          1
        )
      : _c("div", [
          Object.keys(_vm.paymentRequestData.sentRequests).length
            ? _c(
                "div",
                { staticClass: "mb-4" },
                [
                  _c("h2", { staticClass: "mb-3" }, [
                    _vm._v(
                      "\n                Erstellte Zahlungsaufforderungen\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.paymentRequestData.sentRequests,
                    function (sentRequest, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "card mb-3" },
                        [
                          _c("div", { staticClass: "card-header mb-1" }, [
                            _c("strong", [
                              _vm._v(
                                "Zahlungsaufforderung vom " +
                                  _vm._s(sentRequest.date)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Verwendungszweck:")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              " " +
                                _vm._s(sentRequest.reference) +
                                "\n                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body mb-2" }, [
                            sentRequest.assets
                              ? _c("div", [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      sentRequest.assets,
                                      function (asset, aIndex) {
                                        return _c(
                                          "li",
                                          { key: aIndex, staticClass: "mb-1" },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(asset.label)
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("strong", [_vm._v("Betrag:")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatCurrencyCents(
                                                    asset.amount
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            sentRequest.payments
                              ? _c("div", [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      sentRequest.payments,
                                      function (payment, pIndex) {
                                        return _c(
                                          "li",
                                          { key: pIndex, staticClass: "mb-1" },
                                          [
                                            _vm._v(
                                              "\n                                Zahlungseingang am " +
                                                _vm._s(payment.date) +
                                                " über\n                                "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatCurrencyCents(
                                                    payment.amount
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            payment.iban
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                                    von " +
                                                      _vm._s(
                                                        payment.senderName
                                                      ) +
                                                      ", " +
                                                      _vm._s(payment.iban) +
                                                      ",\n                                    " +
                                                      _vm._s(payment.bic) +
                                                      ", " +
                                                      _vm._s(payment.bankName) +
                                                      "\n                                "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentRequestData.possibleAssets.length ||
          _vm.paymentRequestData.missingInformation.length
            ? _c("div", [
                _c("h2", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n                Zahlungsaufforderung erstellen\n            "
                  ),
                ]),
                _vm._v(" "),
                _vm.paymentRequestData.missingInformation.length
                  ? _c(
                      "div",
                      { staticClass: "alert alert-warning mb-3" },
                      _vm._l(
                        _vm.paymentRequestData.missingInformation,
                        function (warning, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(warning) +
                                "\n                "
                            ),
                          ])
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.paymentRequestData.possibleAssets.length
                  ? _c("div", [
                      _c("strong", [_vm._v(" Positionen auswählen ")]),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass: "table table-striped align-middle mb-3",
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.paymentRequestData.possibleAssets,
                              function (request, index) {
                                return _c("tr", { key: index }, [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedAssets,
                                          expression: "selectedAssets",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        value: request,
                                        checked: Array.isArray(
                                          _vm.selectedAssets
                                        )
                                          ? _vm._i(
                                              _vm.selectedAssets,
                                              request
                                            ) > -1
                                          : _vm.selectedAssets,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.selectedAssets,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = request,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedAssets =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedAssets = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedAssets = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(request.label))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatCurrencyCents(request.amount)
                                      )
                                    ),
                                  ]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.files.length
                        ? _c("div", [
                            _c("strong", [_vm._v(" Rechnung anhängen ")]),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-striped align-middle mb-3",
                              },
                              [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.files, function (document, index) {
                                    return _c("tr", { key: index }, [
                                      _c("td", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedDocuments,
                                              expression: "selectedDocuments",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: document,
                                            checked: Array.isArray(
                                              _vm.selectedDocuments
                                            )
                                              ? _vm._i(
                                                  _vm.selectedDocuments,
                                                  document
                                                ) > -1
                                              : _vm.selectedDocuments,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.selectedDocuments,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = document,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectedDocuments =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectedDocuments = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectedDocuments = $$c
                                              }
                                            },
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(document.attributes.fileName)
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            document.attributes.fileCategoryName
                                          )
                                        ),
                                      ]),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end mb-3" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          disabled: _vm.hideButton,
                          variant: _vm.hideButton ? "secondary" : "primary",
                        },
                        on: { click: _vm.sendPaymentRequest },
                      },
                      [
                        _vm._v(
                          "\n                    Zahlungsaufforderung senden\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "5%" } }, [
          _vm._v(
            "\n                                Gewählt\n                            "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "55%" } }, [
          _vm._v(
            "\n                                Typ\n                            "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end", staticStyle: { width: "40%" } }, [
          _vm._v(
            "\n                                Betrag\n                            "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "table-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "5%" } }, [
          _vm._v(
            "\n                                    Gewählt\n                                "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "55%" } }, [
          _vm._v(
            "\n                                    Dateiname\n                                "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end", staticStyle: { width: "40%" } }, [
          _vm._v(
            "\n                                    Typ\n                                "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }